// pages/board/board.component.jsx
import React, { useState, useEffect } from "react";
import { DragDropContext, Droppable } from "react-beautiful-dnd";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams, Link } from "react-router-dom";
import {
  db,
  updateDrag,
  updateColumnDrag,
  updateUser,
} from "../../firebase/firebase.utils";
import { Outlet } from "react-router-dom";
import { setStatusType } from "../../redux/space/space.actions";
import StatusTypeBoard from "../../components/dnd/board/status-type-board/status-type-board.component";
import BoardNewStatus from "../../components/board-new-status/board-new-status.component";
import AddButton from "../../components/task-add-btn/AddButton";
import "./board.styles.scss";
import { FaTrashAlt } from "react-icons/fa";
const Board = ({ station, stationTasks, stationTasksFL }) => {
  const users = useSelector((state) => state.user.users);
  const open = useSelector((state) => state.user.currentUser.open);
  const filter = useSelector((state) => state.filter);
  const dispatch = useDispatch();
  // const history = useNavigate();
  const location = useLocation();
  const currentSpaceId = location.pathname.split("/")[2];
  // const { id } = useParams();
  // const currentStationId = id;
  const currentStationId = location.pathname.split("/")[4];
  const [state, setState] = useState([]);
  const [deleteOpacity, setDeleteOpacity] = useState(0);
  const [phaseOrder, setPhaseOrder] = useState(() => station.phaseOrder || []);
  useEffect(() => {
    setPhaseOrder(station.phaseOrder);
    // dispatch(setStatusType(station.statusType));
    // console.log("Phase Order of the project is:", phaseOrder);
  }, [station]);
  // useEffect(() => {
  //   console.log("stationTasks are;", stationTasks);
  //   console.log("stationTasksFL are;", stationTasksFL);
  // }, [filter]);
  const phases = useSelector((state) => state.prjphases.prjphases) || [];
  // useEffect(() => {
  //   setState(station);
  //   dispatch(setStatusType(station.statusType));
  // }, [station]);
  const onDragEnd = (result) => {
    const { destination, source, draggableId } = result;
    setDeleteOpacity(0);
    if (!destination) return;
    if (result.type === "DEFAULT") {
      if (
        destination.droppableId === source.droppableId &&
        destination.index === source.index
      ) {
        return;
      }
      const start = source.droppableId;
      const finish = destination.droppableId;
      // Change order in the same column
      if (start === finish) {
        const index = phases.findIndex(
          (item) => item.id === source.droppableId
        );
        const phaseId = source.droppableId;
        const phase = phases[index];
        const copiedItems = [...phase.taskIds];
        const [removed] = copiedItems.splice(source.index, 1);
        copiedItems.splice(destination.index, 0, removed);
        updateDrag(currentSpaceId, currentStationId, phaseId, copiedItems);
        return;
      }
      // on drag delete
      if (destination.droppableId === "delete") {
        console.log("we are at", "if delete");
        const index = phases.findIndex(
          (item) => item.id === source.droppableId
        );
        const phaseId = source.droppableId;
        const phase = phases[index];
        const copiedItems = [...phase.taskIds];
        copiedItems.splice(source.index, 1);
        updateDrag(currentSpaceId, currentStationId, phaseId, copiedItems);
        db.collection("space")
          .doc(currentSpaceId)
          .collection("stations")
          .doc(currentStationId)
          .collection("tasks")
          .doc(draggableId)
          .delete();
        return;
      }
      // moving from one column to another
      console.log("we are at", "moving from one list to another");
      const sourceindex = phases.findIndex(
        (item) => item.id === source.droppableId
      );
      const sourcephaseId = source.droppableId;
      const sourcephase = phases[sourceindex];
      const sourcecopiedItems = [...sourcephase.taskIds];
      const [removed] = sourcecopiedItems.splice(source.index, 1);
      const destinationindex = phases.findIndex(
        (item) => item.id === destination.droppableId
      );
      const destinationphaseId = destination.droppableId;
      const destinationphase = phases[destinationindex];
      const destinationcopiedItems = [...destinationphase.taskIds];
      destinationcopiedItems.splice(destination.index, 0, removed);
      updateDrag(
        currentSpaceId,
        currentStationId,
        sourcephaseId,
        sourcecopiedItems
      );
      updateDrag(
        currentSpaceId,
        currentStationId,
        destinationphaseId,
        destinationcopiedItems
      );
      db.collection("space")
        .doc(currentSpaceId)
        .collection("stations")
        .doc(currentStationId)
        .collection("tasks")
        .doc(draggableId)
        .update({
          phase: destinationphaseId,
        });
      return;
    } else {
      // Reorder Columns
      const newStatusOrder = Array.from(phaseOrder);
      newStatusOrder.splice(source.index, 1);
      newStatusOrder.splice(destination.index, 0, draggableId);
      console.log("we are at", "Phases reorder");
      // const newState = {
      //   ...state,
      //   statusOrder: newStatusOrder,
      // };
      // setState(newState);
      setPhaseOrder(newStatusOrder);
      updateColumnDrag(currentSpaceId, currentStationId, newStatusOrder);
    }
  };
  const onDragStart = (result) => {
    if (result.type === "DEFAULT") {
      setDeleteOpacity(1);
    }
  };
  return (
    <div className="boardView" style={{marginLeft: open ? 0 : 15}}>
      <DragDropContext onDragEnd={onDragEnd} onDragStart={onDragStart}>
        <div className="boardContainer">
          <Droppable
            droppableId={"allStatusTypes"}
            type="column"
            direction="horizontal"
          >
            {(provided) => {
              return (
                <div
                  className="board"
                  ref={provided.innerRef}
                  {...provided.droppableProps}
                >
                  <>
                    {[...phases]
                      .sort(
                        (a, b) =>
                          phaseOrder?.indexOf(a.id) - phaseOrder?.indexOf(b.id)
                      )
                      .map((phase, index) => {
                        return (
                          // <div>
                          //   {phase.name}
                          // </div>
                          <StatusTypeBoard
                            currentSpaceId={currentSpaceId}
                            currentStationId={currentStationId}
                            key={phase.id}
                            status={phase}
                            tasks={phase.taskIds}
                            index={index}
                            stationTasksFL={stationTasksFL}
                          />
                        );
                      })}
                    {provided.placeholder}
                    {/* </div>
                ))} */}
                  </>
                  <div className="statusType board__newStatus">
                    <BoardNewStatus />
                  </div>
                </div>
              );
            }}
          </Droppable>
          <div
            className="board__dragDelete"
            style={{
              opacity: deleteOpacity,
            }}
          >
            <Droppable droppableId="delete">
              {(provided, snapshot) => {
                const style = {
                  backgroundColor: snapshot.isDraggingOver
                    ? "rgba(0,0,0,0.05)"
                    : "",
                  borderRadius: "8px",
                  position: "absolute",
                  // bottom: "0px",
                  // height: "10vh",
                };
                return (
                  <>
                    <div
                      ref={provided.innerRef}
                      {...provided.droppableProps}
                      style={style}
                    >
                      {/* <FaTrashAlt size="1em" /> */}
                      <section>
                        <span class="trash">
                          <span></span>
                          <i></i>
                        </span>
                      </section>
                    </div>
                    <div className="board__placeholder" style={style}>
                      {provided.placeholder}
                    </div>
                  </>
                );
              }}
            </Droppable>
          </div>
        </div>
      </DragDropContext>
      <Outlet />
      <AddButton />
    </div>
  );
};
export default Board;
